import { render, staticRenderFns } from "./tableWrap.vue?vue&type=template&id=96fed2fe&scoped=true&"
import script from "./tableWrap.vue?vue&type=script&lang=js&"
export * from "./tableWrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96fed2fe",
  null
  
)

export default component.exports